import { useNavigate } from "react-router-dom";
import { articlesData } from "@/mocks/articles";

export default function SEOGuidesSection() {
  const navigate = useNavigate();

  return (
    <section id="guides" className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-12">
          <p className="text-xs font-label font-semibold uppercase tracking-wider text-foreground-500 mb-3">
            Learn & Master
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
            Master MuleBuy Spreadsheet
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-[560px]">
            12 in-depth guides covering everything from beginner basics to advanced strategies, safety tips, price tracking, and community insights.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articlesData.map((article) => (
            <button
              key={article.id}
              onClick={() => navigate(`/article/${article.slug}`)}
              className="group bg-background-100 rounded-xl overflow-hidden text-left border border-background-200/50 hover:border-background-300/80 hover:bg-background-50 transition-all cursor-pointer"
            >
              <div className="relative w-full h-36 md:h-40 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.imageAlt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute bottom-2 left-3 flex items-center gap-2">
                  <span className="w-8 h-8 rounded-lg bg-background-50/90 backdrop-blur-sm flex items-center justify-center">
                    <i className={`${article.icon} text-foreground-800 text-sm`}></i>
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {article.description}
                </p>
                <span className="inline-flex items-center gap-1.5 text-xs font-label font-semibold text-primary-600">
                  Read Guide
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}